import { render, staticRenderFns } from "./TotalsCard.vue?vue&type=template&id=403160be"
import script from "./TotalsCard.vue?vue&type=script&lang=js"
export * from "./TotalsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports